import { COLOR_ELEVATION_01 } from "./../../config";
import styled from "styled-components";
import {
  COLOR_ADEGA_BLUE,
  COLOR_ADEGA_BLUE_HEX,
  COLOR_DASHBOARD_ELEVATION_01,
  hexToRgba,
  MOBILE_WIDTH,
  spacing,
} from "../../config";
import { RxHamburgerMenu } from "react-icons/rx";
import { GREEN_GRADIENT } from "../../styleConfig";
export const MainContainer = styled.div`
  z-index: 3;
  width: 100%;
  height: 70px;
  min-height: 70px;
  background: rgb(0,33,17);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  padding: ${spacing(1)} ${spacing(5)};
  justify-content: flex-end;

  & svg {
    color: ${COLOR_ELEVATION_01};
    border: 4px solid transparent;
    width: 40px;
    height: 40px;
    border-radius: 6px;
    padding: ${spacing(0.3)};
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      border: 4px solid rgba(${hexToRgba(COLOR_ADEGA_BLUE_HEX, 0.25)});
    }
  }

  @media (max-width: ${MOBILE_WIDTH}) {
    justify-content: space-between;
  }
`;

export const Hamburguer = styled(RxHamburgerMenu)`
  display: none;
  color: ${COLOR_ADEGA_BLUE};
  cursor: pointer;
  font-weight: bold;

  @media (max-width: ${MOBILE_WIDTH}) {
    display: block;
  }
`;

export const ShowLocation = styled.p`
  display: none;
  height: 100%;
  color: ${COLOR_ELEVATION_01};

  @media (max-width: ${MOBILE_WIDTH}) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const MenuPopup = styled.div`
  position: absolute;
  top: 60px;
  right: 30px;
  width: 200px;
  height: fit-content;
  background-color: ${COLOR_DASHBOARD_ELEVATION_01};
  z-index: 1000000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: ${spacing(2)};
  max-height: 300px;
  overflow-y: auto;
  border-radius: 2px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

export const MenuIconWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-direction: column;
`;

export const MenuPopupTip = styled.div`
  position: absolute;
  top: 135%;
  left: 50%;
  height: 15px;
  width: 15px;
  background-color: ${COLOR_DASHBOARD_ELEVATION_01};
  transform: translate(-50%, -50%) rotate(45deg);
  z-index: 1000;
`;

export const MenuItem = styled.div`
  width: 100%;
  height: fit-content;
  border-bottom: 1px solid lightgray;
  border-radius: 2px;
  z-index: 1000000000;
  background-color: ${COLOR_ELEVATION_01};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: ${spacing(1)} ${spacing(2)};
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    background-color: ${COLOR_ADEGA_BLUE};
    color: white;
  }
  &:hover p {
    color: white;
  }
`;

export const MenuSelect = styled.select`
  width: 100%;
  height: 32px;
  border: none;
  background-color: transparent;
  color: ${COLOR_ADEGA_BLUE};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  outline: none;
  border-bottom: 1px solid lightgray;
  padding-left: ${spacing(3.5)};
`;
export const MenuSelectOption = styled.option`

  height: 100%;
  border: none;
  background-color: transparent;
  color: ${COLOR_ADEGA_BLUE};
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  padding: ${spacing(2)};
  z-index: 100000000000000;
 
`;

interface IMenuIcon {
  backgroundColor: string;
}

export const MenuIcon = styled.div<IMenuIcon>`

  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color : ${(props) => props.backgroundColor};
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  padding: 10px;

  & p{
    font-size: 90%;
    color: white;
    mix-blend-mode: screen;
  }
`;
export const MenuIconText = styled.p`

  font-size: 10px;
  margin-bottom: -10px;
  color: white;
  font-weight: 500;
`;
export const MenuText = styled.p`
  font-size: 16px;
  color: black;
  font-weight: 500;
  margin-left: ${spacing(2)};
`;

